import { jsx as o, jsxs as O, Fragment as T } from "react/jsx-runtime";
import { c as B } from "./clsx-OuTLNxxd.js";
import { forwardRef as I } from "react";
import { I as n } from "./icon-D_HK7aSj.js";
import "./components/elements/icon/iconsList.js";
import { Loader as k } from "./components/elements/loader/loader.js";
const x = "_button_pocty_29", S = "_disabled_pocty_43", C = "_loader_pocty_263", s = {
  button: x,
  disabled: S,
  "is-primary": "_is-primary_pocty_51",
  "is-contrasted": "_is-contrasted_pocty_65",
  "is-secondary": "_is-secondary_pocty_74",
  "is-tertiary": "_is-tertiary_pocty_97",
  "is-eco-green": "_is-eco-green_pocty_120",
  "is-ghost": "_is-ghost_pocty_134",
  "is-destructive": "_is-destructive_pocty_157",
  "is-hollow": "_is-hollow_pocty_171",
  "is-destructive-ghost": "_is-destructive-ghost_pocty_189",
  "is-facebook": "_is-facebook_pocty_203",
  "is-apple": "_is-apple_pocty_217",
  "is-google": "_is-google_pocty_231",
  "is-regular": "_is-regular_pocty_245",
  "is-medium": "_is-medium_pocty_248",
  "is-small": "_is-small_pocty_251",
  "is-full-width": "_is-full-width_pocty_254",
  "is-loading": "_is-loading_pocty_257",
  loader: C,
  "dialog-overlay-show": "_dialog-overlay-show_pocty_1",
  "dialog-content-show": "_dialog-content-show_pocty_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_pocty_1"
}, U = I(
  ({
    color: p = "primary",
    text: y,
    size: g = "regular",
    isFullWidth: m = !1,
    icon: t,
    iconPosition: e = "left",
    iconSize: a,
    onClick: u,
    children: h,
    disabled: i,
    type: f = "button",
    className: b = "",
    href: l,
    isLoading: r,
    isContrasted: w = !1,
    ...v
  }, _) => {
    const N = B(
      s.button,
      s[j[p]],
      s[z[g]],
      m && s["is-full-width"],
      i && s.disabled,
      e === "right" && s["has-icon-right"],
      w && s["is-contrasted"],
      r && s["is-loading"],
      b
    ), c = /* @__PURE__ */ O(T, { children: [
      r && /* @__PURE__ */ o(k, { className: s.loader, onDark: !0, size: "small" }),
      t && e === "left" && /* @__PURE__ */ o(n, { color: "inherit", size: a, name: t }),
      h ?? y,
      t && e === "right" && /* @__PURE__ */ o(n, { color: "inherit", size: a, name: t })
    ] }), d = {
      onClick: u,
      className: N,
      ...v
    };
    return l ? /* @__PURE__ */ o("a", { href: i ? void 0 : l, ref: _, ...d, children: c }) : /* @__PURE__ */ o(
      "button",
      {
        ref: _,
        disabled: r || i,
        type: f,
        ...d,
        children: c
      }
    );
  }
);
U.displayName = "Button";
const j = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, z = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
}, A = {
  left: "left",
  right: "right"
};
export {
  U as B,
  j as a,
  z as b,
  A as c
};
